import React from 'react'

interface BadgeProps {
 children: React.ReactNode
 variant?: 'primary' | 'success' | 'danger' | 'warning' | 'info' | 'gray'
 size?: 'sm' | 'md' | 'lg'
 className?: string
}

const variantClasses = {
 primary: 'bg-accent dark:bg-primary-500 text-white',
 success: 'bg-green-600 dark:bg-green-500 text-white',
 danger: 'bg-red-600 dark:bg-red-500 text-white',
 warning: 'bg-yellow-600 dark:bg-yellow-500 text-white',
 info: 'bg-blue-600 dark:bg-blue-500 text-white',
 gray: 'bg-gray-600 text-white'
}

const sizeClasses = {
 sm: 'px-2 py-0.5 text-xs',
 md: 'px-2.5 py-1 text-sm',
 lg: 'px-3 py-1.5 text-base'
}

export const Badge: React.FC<BadgeProps> = ({
 children,
 variant = 'primary',
 size = 'sm',
 className = ''
}) => {
 return (
 <span className={`
 inline-flex items-center font-medium rounded-full
 ${variantClasses[variant]}
 ${sizeClasses[size]}
 ${className}
 `}>
 {children}
 </span>
 )
}

